import { render, staticRenderFns } from "./Instructions.vue?vue&type=template&id=2668aefc&scoped=true"
import script from "./Instructions.vue?vue&type=script&lang=ts"
export * from "./Instructions.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=2668aefc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2668aefc",
  null
  
)

export default component.exports